import {
    userShortDateFormatter,
    userShortDateTimeFormatter
} from '~/components/Table2/Framework/ValueFormatter/formatAsUser';

import { getDateUnitTranslationObj } from '~/modules/helpers/date';
import { translate } from '~/modules/helpers/lang';

export const noDataColType = 'NODATA';

export const columnTypes = Object.freeze({
    /*
	   𝘛𝘺𝘱𝘦𝘭𝘦𝘴𝘴 𝘵𝘳𝘦𝘢𝘵𝘦𝘥 𝘢𝘴 𝘴𝘵𝘳𝘪𝘯𝘨
	   - owner
	   - generated_by
	   - created_by
	   - folder ( 𝘮𝘢𝘺 𝘣𝘦 𝘯𝘶𝘭𝘭 )
	   - involved ( 𝘵𝘳𝘶𝘦/𝘧𝘢𝘭𝘴𝘦 )
	   - deleted ( 𝘵𝘳𝘶𝘦/𝘧𝘢𝘭𝘴𝘦 )
	*/
    [noDataColType]: {
        headerClass: 'col-nodata',
        cellClass: 'cell-nodata'
    },

    // 0: ( 𝘧𝘪𝘦𝘭𝘥𝘴 𝘢𝘴 'investigation_number', 'description', 'incidentid', ... )
    TEXT: {
        headerClass: 'col-text',
        cellClass: 'cell-text',
        cellRenderer: 'plainText'
    },

    // 1: ( 𝘧𝘪𝘦𝘭𝘥𝘴 𝘢𝘴 'status', 'incident_kind', 'incident_category', ... )
    LIST: {
        headerClass: 'col-list',
        cellClass: 'cell-list'
    },

    // 2: ( 𝘧𝘪𝘦𝘭𝘥𝘴 𝘢𝘴 'checkbox', 'deleted', 'involved', 'inhibit_phases', ... )
    CHECKBOX: {
        headerClass: 'col-checkbox',
        cellClass: 'cell-checkbox no-strikethrough',
        cellRenderer: 'checkbox'
    },

    // 3:
    DATE: {
        headerClass: 'col-date',
        cellClass: 'cell-date',
        valueFormatter: userShortDateFormatter
    },

    // 4: ( 𝘧𝘪𝘦𝘭𝘥𝘴 𝘢𝘴 'starttime', 'reporttime', 'endtime', 'openingtime', 'detecttime', ... )
    TIME: {
        headerClass: 'col-time',
        cellClass: 'cell-time',
        valueFormatter: userShortDateTimeFormatter
    },

    // 6:
    TIMEZONE: {
        headerClass: 'col-timezone',
        cellClass: 'cell-timezone'
    },

    // 7: ( 𝘧𝘪𝘦𝘭𝘥𝘴 𝘢𝘴 'tags', ... )
    TAGS: {
        headerClass: 'col-tags',
        cellClass: 'cell-tags right-gradient-mask',
        cellRenderer: 'tags'
    },

    // 8:
    DYNAMIC: {
        headerClass: 'col-dynamic',
        cellClass: 'cell-dynamic'
    },

    // 9:
    LINK: {
        headerClass: 'col-link',
        cellClass: 'cell-link'
    },

    // 10:
    COLOR: {
        headerClass: 'col-color',
        cellClass: 'cell-color',
        cellRenderer: 'color'
    },

    // 11:
    LDAP: {
        headerClass: 'col-ldap',
        cellClass: 'cell-ldap'
    },

    // 12: ( 𝘧𝘪𝘦𝘭𝘥𝘴 𝘢𝘴 'type', ... )
    MULTILIST: {
        headerClass: 'col-multilist',
        cellClass: 'cell-multilist'
    },

    // 13:
    IP: {
        headerClass: 'col-ip',
        cellClass: 'cell-ip'
    },

    // 14:
    CALC: {
        headerClass: 'col-calc',
        cellClass: 'cell-calc',
        valueFormatter: params => {
            let formattedValue = '';
            if (params) {
                switch (params.colDef?.subtype) {
                    case 'date':
                        formattedValue = userShortDateFormatter(params);
                        break;
                    default: {
                        const paramsValue = params.value;
                        formattedValue =
                            (paramsValue?.hasOwnProperty?.('value')
                                ? paramsValue.value
                                : paramsValue) ?? '';
                    }
                }
            }
            return formattedValue;
        }
    },

    // 15:
    HASH: {
        headerClass: 'col-hash',
        cellClass: 'cell-hash'
    },

    // 16:
    EMAIL: {
        headerClass: 'col-email',
        cellClass: 'cell-email'
    },

    // 17:
    URL: {
        headerClass: 'col-url',
        cellClass: 'cell-url'
    },

    // 18:
    FILENAME: {
        headerClass: 'col-filename',
        cellClass: 'cell-filename'
    },

    // 19:
    USER: {
        headerClass: 'col-user',
        cellClass: 'cell-user'
    },

    // 20:
    NUMERIC: {
        headerClass: 'col-numeric',
        cellClass: 'cell-numeric'
    },

    // 21:
    TIMEINTERVAL: {
        headerClass: 'col-timeinterval',
        cellClass: 'cell-timeinterval',
        valueFormatter: params => {
            let formattedValue = '';
            if (params) {
                const paramsValue = params.value;
                if (paramsValue?.hasOwnProperty?.('value')) {
                    const { unit, value } = paramsValue;
                    if (
                        // y|m|w|d|h|i|s
                        '' !== unit &&
                        '' !== value
                    ) {
                        formattedValue = `${value} ${translate(
                            getDateUnitTranslationObj(unit).message
                        )}`;
                    }
                } else {
                    formattedValue = paramsValue ?? '';
                }
            }
            return formattedValue;
        }
    },

    // 22:
    TEXTAREA: {
        headerClass: 'col-textarea',
        cellClass: 'cell-textarea'
    },

    // 23:
    DESCRIPTION: {
        headerClass: 'col-description',
        cellClass: 'cell-description'
    },

    // 24:
    PASSWORD: {
        headerClass: 'col-password',
        cellClass: 'cell-password'
    },

    // 25:
    INVOLVEDINCIDENTS: {
        headerClass: 'col-involved-incidents',
        cellClass: 'cell-involved-incident right-gradient-mask',
        cellRenderer: 'involvedIncidents',
        valueFormatter: params =>
            params.value?.details?.map(e => e.name).join() || ''
    }
});

/**
 * Reduces an array of columns to only include visible columns based on a given function.
 * @param {Array} columns - The array of columns to reduce.
 * @param {Function} [fn] - A function that handle each column.
 * 𝘐𝘧 𝘱𝘳𝘰𝘷𝘪𝘥𝘦𝘥, 𝘪𝘵 𝘴𝘩𝘰𝘶𝘭𝘥 𝘢𝘤𝘤𝘦𝘱𝘵 𝘢 𝘤𝘰𝘭𝘶𝘮𝘯 𝘰𝘣𝘫𝘦𝘤𝘵 𝘢𝘴 𝘪𝘵𝘴 𝘱𝘢𝘳𝘢𝘮𝘦𝘵𝘦𝘳 𝘢𝘯𝘥 𝘳𝘦𝘵𝘶𝘳𝘯 𝘢𝘯 𝘰𝘣𝘫𝘦𝘤𝘵 𝘳𝘦𝘱𝘳𝘦𝘴𝘦𝘯𝘵𝘪𝘯𝘨 𝘵𝘩𝘦 𝘷𝘪𝘴𝘪𝘣𝘭𝘦 𝘤𝘰𝘭𝘶𝘮𝘯.
 * 𝘐𝘧 𝘯𝘰𝘵 𝘱𝘳𝘰𝘷𝘪𝘥𝘦𝘥, 𝘢𝘭𝘭 𝘤𝘰𝘭𝘶𝘮𝘯𝘴 𝘸𝘪𝘭𝘭 𝘣𝘦 𝘪𝘯𝘤𝘭𝘶𝘥𝘦𝘥 𝘢𝘴 𝘪𝘴.
 * @returns {Array} An array containing the visible/valid columns
 */
export const reduceToVisibleColumns = (columns, fn) => {
    const reduced = [];
    if (columns?.length) {
        const process = fn
            ? column => {
                  const obj = fn(column);
                  if (obj) {
                      reduced.push(obj);
                  }
              }
            : column => {
                  reduced.push(column);
              };
        for (const column of columns) {
            const { colDef } = column;
            if (!colDef.hide && noDataColType !== colDef.type && colDef.field) {
                process(column);
            }
        }
    }
    return reduced;
};

export const reduceToVisibleColumnsFieldAndSortInfo = columns => {
    return reduceToVisibleColumns(columns, col => {
        const e = {
            field: col.colDef.field // (at this point invalid columns are already discarded)
        };
        if (col.sort?.length) {
            e.sort = col.sort;
        }
        return e;
    });
};

export const getVisibleColumnsFieldAndSortInfo = table => {
    const allColumns = table.gridApi?.columnApi?.getAllColumns();
    return reduceToVisibleColumnsFieldAndSortInfo(allColumns);
};
